
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class GWattMinModal extends Vue {

    @Prop({
        default: () => new OM.GWattMinM3Model()
    }) model: OM.GWattMinM3Model;

    localModel: OM.GWattMinM3Model = new OM.GWattMinM3Model();

    @Prop() callback: any;

    created() {
        this.localModel = this.model;
    }

    get canSave(){
        return this.localModel.grams.key && this.localModel.watt.key && this.localModel.minutes.key && this.localModel.m3 && this.localModel.naturalGasEmissionFactor > 0;
    }

    save() {
        if(!this.canSave)
            return;

        this.callback(this.localModel);
    }
    
}
